import React from "react";
import PropTypes from 'prop-types';
import {MGButton, ProgressBar} from "mgUiKit";

class WidgetPin extends React.Component{

    constructor(props){
        super(props);  
        this.state = {             
            pinStateOpen: props.stateOpen,            
            type: props.type,
            initialStateClosed: props.initialStateClosed
        }         
        this.changeState = this.changeState.bind(this);
    }

    componentDidMount(){      
    }

    componentWillReceiveProps(nextProps){
        
        this.setState({
            initialStateClosed: nextProps.initialStateClosed,
            pinStateOpen: nextProps.stateOpen
        });
    }

    changeState(){
    
        // Se il pin è chiuso e lo voglio aprire, metto in anteprima gli altri        
        if(!this.state.pinStateOpen && this.state.initialStateClosed)
            this.context.changeOtherPins(this.props.type);

        this.setState({
            pinStateOpen: !this.state.pinStateOpen,
          //  initialStateClosed: this.state.pinStateOpen
        });

        
    }
    
    render(){    
        
        var _pinClass = "mg-pin pin-" + this.props.type;
        var _pinContentClass = "pin-content pin-content--" + this.props.type;
        if(this.state.pinStateOpen)
            _pinClass += " pin-extended";
        if(!this.state.initialStateClosed)
            _pinClass += " pin-open";

        var _pinIconClass = "pin-icon icon-" + this.props.type;
        var _widgetContent = <p>WIDGET CONTENT </p>;
        var _widgetTitle = "WIDGET TITLE";
        var _widgetPreview = <h3>ANTEPRIMA INFO</h3>;        

        if(this.state.type == "suggeriti"){
            _widgetTitle = "Suggeriti";
            _widgetPreview = "";
            _widgetContent = this.props.content.content;
        }
        else if(this.state.type == "sbloccofb"){
            _widgetTitle = "% funbonus";            
            _widgetPreview = "";
            _widgetContent = <><p className="sbloccofb-info">
                I tuoi progressi sono aggiornati automaticamente ogni <span>15</span> secondi
                </p>
                <ProgressBar percentage={53} /></>;
        }    
        else if(this.state.type == "vipsystem"){
            _widgetTitle = "Vip System";            
            _widgetPreview = "";
        }        
        else if(this.state.type == "topwin"){
            _widgetTitle = "Top win";
            _widgetPreview = "";
            var _winners = this.props.content.content;
            var winnersHtml = [];
            for(var i=0; i<_winners.length; i++){
                //var imgSrc = "/l.ashx?s=default&u=default/casino/thumbs/game-code/" + _winners[i].GameCode +".jpg";
                var imgSrc = "/l.ashx?s=default&u=default/casino/thumbnails/" + 
                    _winners[i].GameCode.toUpperCase() + ".jpg";    

                var _keywin = "win-" + i;
                    
                var _value = _winners[i].Value.toFixed(2).replace('-', '');                
                winnersHtml.push(                                       
                    <li key={_keywin} className="topwin-list--win">
                        <img className="win-thumbnail" 
                            alt={_winners[i].GameName} src={imgSrc}></img>
                        <ul className="win-details">
                            <li className="win-details--user">
                                <span title={_winners[i].UserNickName}>{_winners[i].UserNickName}</span>
                            </li>
                            <li className="win-details--amount">ha vinto <span>{_value} €</span></li>
                            <li className="win-details--game">Gioco: <span title={_winners[i].GameName}>{_winners[i].GameName}</span></li>
                        </ul>                         
                    </li>
                );
            }

            _widgetContent =             
               <ul className="topwin-list">
                   {winnersHtml}                    
                </ul>;
          
        }
        else if(this.state.type == "ranking"){
            _widgetPreview = <h3>2° con 8708 punti</h3>;
            _widgetTitle = "Classifica";
            _widgetContent = 
                <div>
                    <h3 className="pin-ranking--promo-title">Dreamlike Games</h3>
                    <h4 className="pin-ranking--promo-life">Termina tra: 2 giorni 12:3:56</h4>
                    <table className="pin-ranking--promo-table">
                    <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Nickname</th>
                            <th>Score</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>1</td>
                        <td>mussitta79</td>
                        <td>20412</td>
                    </tr>
                    <tr className="promo-table--user-position">
                        <td>2</td>
                        <td>polian500</td>
                        <td>8708</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>iulyka9oooo0</td>
                        <td>8286</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>vituccio79</td>
                        <td>7066</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>1039fcesa</td>
                        <td>6891</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>onesto64</td>
                        <td>6494</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>tiziano7900</td>
                        <td>5802</td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td>xxxcalistexxx</td>
                        <td>5742</td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td>carmeloct86</td>
                        <td>5438</td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td>ubner0307</td>
                        <td>5372</td>
                    </tr>

                    </tbody>
                    </table>
                    <div className="pin-ranking--promo-link">
                        <MGButton
                            title=""
                            class=""
                            label="Vai alla promo"
                            disabled={false}
                            primary={true}                     
                            href="#"
                            fullWidth={true}                           
                        />                        
                    </div>
                </div>;                
          
        }
        else if(this.state.type == "jackpot"){
            _widgetPreview = "";
            _widgetTitle = "jackpot";
            var _jackpotsList = this.props.content.content;
            var _jackpotLi = [];
             
            for (var key in _jackpotsList) {
                var name = _jackpotsList[key].Name;
                var jClass = "jackpot " + name.toLowerCase().replace(/ /g, '-');
                
                _jackpotLi.push(
                    <li 
                        key={key}
                        className={jClass}>
                        <span className="jackpot-title">{name}</span>
                        <span className="jackpot-value">{_jackpotsList[key].AmountForDisplay.split(',')[0]}</span>
                    </li>
                )             
            }
           
            _widgetContent = 
                <ul className="jackpot-list">
                    {_jackpotLi}                    
                </ul>;
        }


        return(
            <div className={_pinClass}>
                
                <div title={_widgetTitle} onClick={this.changeState} className="pin-header">
                    <div className="pin-header_icon">
                        <i className={_pinIconClass}></i>
                    </div>
                    {!this.state.initialStateClosed || this.state.pinStateOpen ?
                        <div className="pin-header_title">
                            <h2>{_widgetTitle}</h2>
                            {_widgetPreview}
                        </div>
                    : ""}
                </div>                    
                {this.state.pinStateOpen ?
                    <div className={_pinContentClass}>{_widgetContent}</div> : ""
                }
            </div>          
        )   
    }    
}

WidgetPin.displayName = "WidgetPinComponent";

// PropTypes validation
WidgetPin.propTypes = {
     type: PropTypes.string.isRequired,
     stateOpen: PropTypes.bool,
     initialStateClosed: PropTypes.bool,
     changeState: PropTypes.func,
     content: PropTypes.object
};

// default props
WidgetPin.defaultProps = {
};

WidgetPin.contextTypes = {
    changeOtherPins: PropTypes.func 
}

export default WidgetPin;